import React, { useEffect, useState, Fragment } from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@mui/styles'
import { useSelector, useDispatch } from 'react-redux'
import { Field } from 'formik'

import lang from '@/lang'

import { Title } from '@/modules/base/components/texts'
import { ButtonSquare } from '@/modules/base/components/buttons'

import { fetchScopes } from 'redux/ducks/apps'

const Scopes = ({ disabled }) => {
  const dispatch = useDispatch()
  const { scopes } = useSelector(state => state.apps)
  const [selectScopes, setSelectScopes] = useState(false)

  const classes = useStyles({ selectScopes }, [selectScopes])

  const scopesLang = lang.marketplace.form.details.sections.scopes

  useEffect(() => {
    dispatch(fetchScopes())
  }, [])

  return (
    <Fragment>
      <Title size="small" className={classes.sectionHeadline}>{scopesLang.headline}</Title>
      <p dangerouslySetInnerHTML={{ __html: scopesLang.text }} />
      <div className={classes.selectScopes}>
        <div className={classes.scopesContent}>
          {Object.entries(scopes).map(([key, value], idx) => (
            <Fragment key={key}>
              <div className={classes.scopeSection}>
                <p><strong>{value.name}</strong></p>
                <ul>
                  {value.scopes.map(({ label, value }) => {
                    const [scope, verb] = label.split(' ')
                    return (
                      <li key={label}>
                        <label className={classes.scopeLabel}>
                          <Field
                            className={classes.scopeCheckbox}
                            type="checkbox"
                            name="apiScopes"
                            value={value}
                            disabled={disabled}
                          />
                          {scope}&nbsp;
                          <span className={classes[`verb${verb}`]}>{verb}</span>
                        </label>
                      </li>
                    )
                  })}
                </ul>
              </div>
              {idx + 1 < Object.keys(scopes).length && (<hr />)}
            </Fragment>
          ))}
        </div>
      </div>
      <ButtonSquare
        className={classes.editScope}
        onClick={() => setSelectScopes(!selectScopes)}
      >
        {scopesLang.inputs.button}
      </ButtonSquare>
    </Fragment>
  )
}

Scopes.propTypes = {
  disabled: PropTypes.bool,
}

Scopes.defaultProps = {
  disabled: false,
}

const useStyles = makeStyles(theme => ({
  editScope: ({ selectScopes }) => ({
    display: selectScopes ? 'none' : 'flex',
    width: 220,
  }),
  selectScopes: ({ selectScopes }) => ({
    height: selectScopes ? 300 : 0,
    transition: 'height .5s',
    marginBottom: selectScopes ? 20 : 0,
    overflow: 'auto',
  }),
  scopesContent: {
    padding: 20,
  },
  scopeSection: {
    '& p': {
      marginBottom: 8,
    },
  },
  scopeCheckbox: {
    marginRight: 10,
  },
  scopeLabel: {
    display: 'flex',
    alignItems: 'center',
    padding: '5px',
    cursor: 'pointer',
    margin: '0 -5px',
    '&:hover': {
      backgroundColor: theme.backgroundLight,
    },
  },
  verblesen: { color: '#43b2ff' },
  verberstellen: { color: '#00d08c' },
  verbbearbeiten: { color: '#00e7c0' },
  verbanzeigen: { color: '#43b2ff' },
}))

export default Scopes
